"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.localeConsumerDecorator = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _excluded = ["locale"];

var _this = void 0;

var useLocale = _reactComponents.LocaleProvider.useLocale;

var localeConsumerDecorator = function localeConsumerDecorator(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var _ref$defaultLocale = _ref.defaultLocale,
      defaultLocale = _ref$defaultLocale === void 0 ? {} : _ref$defaultLocale,
      localeName = _ref.localeName;
  return function (Child) {
    var _this3 = this;

    (0, _newArrowCheck2["default"])(this, _this2);

    // eslint-disable-next-line react/display-name
    var LocalConsumerWrappedComponent = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
      (0, _newArrowCheck2["default"])(this, _this3);
      var locale = _ref2.locale,
          rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
      var finalLocale = useLocale(defaultLocale, localeName, locale);
      return /*#__PURE__*/_react["default"].createElement(Child, (0, _extends2["default"])({}, rest, {
        locale: finalLocale,
        ref: ref
      }));
    }.bind(this));

    LocalConsumerWrappedComponent.propTypes = {
      locale: _propTypes["default"].object
    };
    return LocalConsumerWrappedComponent;
  }.bind(this);
}.bind(void 0);

exports.localeConsumerDecorator = localeConsumerDecorator;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/utils/localeConsumerDecorator.js
// module id = 1344
// module chunks = 6 7 17 18